/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: feedback_insight.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  ListInsightFindingsRequest,
  ListInsightFindingsResponse,
  ListInsightRunsRequest,
  ListInsightRunsResponse,
  PutInsightRunRequest,
  PutInsightRunResponse,
} from '../types/feedback_insight';

export const createFeedbackInsightService = (transport: Transport) => ({
  async putInsightRun(
    request: PutInsightRunRequest,
    options: RequestOptions = {},
  ): Promise<PutInsightRunResponse> {
    const { organization_id, day, ...body } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.PutInsightRun, {
      organization_id,
      day,
    });
    return transport.post<PutInsightRunResponse>(url, body, options);
  },

  async listInsightRuns(
    request: ListInsightRunsRequest,
    options: RequestOptions = {},
  ): Promise<ListInsightRunsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.ListInsightRuns, { organization_id });
    return transport.get<ListInsightRunsResponse>(url, { params, ...options });
  },

  async listInsightFindings(
    request: ListInsightFindingsRequest,
    options: RequestOptions = {},
  ): Promise<ListInsightFindingsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.ListInsightFindings, {
      organization_id,
    });
    return transport.get<ListInsightFindingsResponse>(url, { params, ...options });
  },
});

export type FeedbackInsightService = ReturnType<typeof createFeedbackInsightService>;
